import { axiosPost, axiosPut } from '@/api/AxiosApi';
import { getOs, getPushId } from '@/component/users/common/Device';
// 핀번호 업데이트
type updatePinProps = {
  bf_pin_num: string;
  pin_num: string;
};
export const updatePin = async (aData: updatePinProps) => {
  const payload = {
    path: '/v1/users/pin',
    body: { ...aData },
  };
  const { data: re } = await axiosPut(payload);
  return re;
};

type changePwProps = {
  email: string;
  current_pw: string;
  now_pw: string;
};
export const changePw = async (aData: changePwProps) => {
  const payload = {
    path: '/v1/users/changepassword',
    body: { ...aData },
  };
  const { data: re } = await axiosPut(payload);
  return re;
};

type setPushTokenProps = {
  fcm_token: string;
  os: string | null;
};

export const updatePushToken = () => {
  // token, os
  const token = getPushId();
  if (!token) {
    return;
  }
  const os = getOs() === 'iphone' ? 'IOS' : 'AOS';
  const payload = {
    fcm_token: token,
    os: os,
  };
  setTimeout( async() => {
    await setPushToken(payload);
  }, 2000);
};
export const setPushToken = async (aData: setPushTokenProps) => {
  const payload = {
    path: '/v1/users/push/set',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// push 응답값
// {
//   multicast_id: 3903135649794559000,
//   success: 1,
//   failure: 0,
//   canonical_ids: 0,
//   results: [ { message_id: '0:1694066842537146%ff90064eff90064e' } ]
// }
